import { computed, inject, onMounted, onUnmounted, ref } from 'vue';
import type { DashboardContext } from '@Shared';

export const HARNESS_DASHBOARD_CONTEXT_CHANGED = 'harness:dashboard-context-changed';

export default function useDashboardContext() {
    const getDashboardContext = inject<() => Promise<DashboardContext>>(
        'backToDashboard:getDashboardContext',
        () => Promise.resolve({ participantPortalEnabled: false, dealId: null }),
    );

    const dashboardContext = ref<DashboardContext | null>(null);
    const isLoadingContext = ref(true);

    const isDashboardContext = computed(
        () => dashboardContext.value?.participantPortalEnabled === true,
    );

    const loadDashboardContext = async () => {
        isLoadingContext.value = true;
        try {
            dashboardContext.value = await getDashboardContext();
        } catch {
            dashboardContext.value = { participantPortalEnabled: false, dealId: null };
        } finally {
            isLoadingContext.value = false;
        }
    };

    const onHarnessDashboardContextChanged = () => loadDashboardContext();

    onMounted(() => {
        loadDashboardContext();

        if (import.meta.env.MODE === 'harness') {
            window.addEventListener(HARNESS_DASHBOARD_CONTEXT_CHANGED, onHarnessDashboardContextChanged);
        }
    });

    onUnmounted(() => {
        if (import.meta.env.MODE === 'harness') {
            window.removeEventListener(HARNESS_DASHBOARD_CONTEXT_CHANGED, onHarnessDashboardContextChanged);
        }
    });

    return {
        dashboardContext,
        isLoadingContext,
        isDashboardContext,
    };
}
